import styled from 'styled-components';
import { Trigger, Icon, Content, Viewport, Item } from '@radix-ui/react-select';

// Local styled components - completely self-contained like RadixMultiSelect
export const SelectRoot = styled.div`
  position: relative;
`;

export const SelectTrigger = styled(Trigger)`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  border-radius: var(--way-design-borderRadiusDefault);
  padding: 12px 14px;
  font-size: 14px;
  line-height: 1;
  height: 54px;
  gap: 12px;
  background-color: transparent;
  border: 0.5px solid var(--way-colors-borderColor);
  color: var(--way-colors-calendarInputColor);
  cursor: pointer;
  outline: none;
  transition: all 0.2s ease;
  width: 100%;

  &:hover {
    border-color: var(--way-colors-borderHoverColor);
  }

  &:focus-visible {
    outline: 2px solid var(--way-colors-focusBorderColor);
  }

  &[data-disabled] {
    opacity: 0.5;
    cursor: not-allowed;
  }

  &[data-placeholder] {
    color: var(--way-colors-contrastColorShades-60);
  }
`;

export const TriggerContent = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  flex: 1;
`;

export const SelectIcon = styled(Icon)`
  color: var(--way-colors-svgColor);
  border-left: 1px solid var(--way-colors-borderColor);
  padding-left: 8px;
`;

export const SelectContent = styled(Content)`
  overflow: hidden;
  background-color: white;
  border-radius: var(--way-design-borderRadiusDefault);
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1),
    0 2px 4px -1px rgba(0, 0, 0, 0.06);
  z-index: 9;
  min-width: var(--radix-select-trigger-width);
  max-width: var(--radix-select-trigger-width);
  max-height: 200px;
`;

export const SelectViewport = styled(Viewport)`
  padding: 8px 4px;
  background-color: white;
`;

export const SelectItem = styled(Item)`
  font-size: 14px;
  border-radius: 4px;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  margin: 4px;
  position: relative;
  user-select: none;
  cursor: pointer;
  color: #051e39;
  background-color: white;
  transition: all 0.15s ease;
  border: 2px solid transparent;
  touch-action: manipulation;

  &[data-highlighted],
  &:hover {
    background-color: var(--way-palette-black-10);
    color: #051e39;
  }

  &[data-state='checked'] {
    background-color: var(--way-palette-black-10);
    color: #051e39;
  }

  &:focus-visible {
    outline: 2px solid var(--way-colors-focusBorderColor);
    background-color: var(--way-palette-black-10);
  }

  &[data-disabled] {
    color: var(--way-palette-charcoal-100);
    cursor: not-allowed;
    background-color: white;
    border: 2px solid transparent;
  }
`;
